export function prefixedTranslations(resources, prefix) {
    var res = {};
    for (var lang in resources) {
        // @ts-ignore
        res[lang] = {};
        // @ts-ignore
        for (var key in resources[lang]) {
            // @ts-ignore
            res[lang]["" + prefix + key] = resources[lang][key];
        }
    }
    return res;
}
